import PropTypes from 'prop-types';
import clsx from 'clsx';

// Components
import Icon from '@/components/base/Icon';

const TableHead = ({
    headerGroups,
    requestParams = {},
    setRequestParams = () => {
        /** */
    }
}) => {
    return (
        <thead>
            {headerGroups?.map((headerGroup, headerKey) => (
                <tr {...headerGroup?.getHeaderGroupProps()} key={headerKey}>
                    {headerGroup?.headers?.map((column, columnKey) => (
                        <th
                            onClick={() => {
                                if (column?.sortable) {
                                    let order = 'asc';
                                    if (requestParams?.sort?.column === column?.sortable) {
                                        if (requestParams?.sort?.order === 'asc') {
                                            order = 'desc';
                                        } else if (requestParams?.sort?.order === 'desc') {
                                            order = '';
                                        }
                                    }

                                    const sort =
                                        order !== ''
                                            ? {
                                                  column: column?.sortable,
                                                  order
                                              }
                                            : undefined;
                                    setRequestParams((prevState) => ({
                                        ...prevState,
                                        sort
                                    }));
                                }
                            }}
                            key={columnKey}
                            className={clsx(
                                'group whitespace-nowrap px-3 pb-m text-left text-xs text-icoBlack dark:text-white',
                                {
                                    'w-[260px]': column?.id === 'content',
                                    'w-[180px]': column?.id === 'name',
                                    'w-[64px]': column?.id === 'type',
                                    'w-[200px]': column?.id === 'recipients',
                                    'w-[152px]':
                                        column?.id === 'frequency' || column?.id === 'period',
                                    'w-[135px]':
                                        column?.id === 'next_execution' ||
                                        column?.id === 'created_at',
                                    'w-20': column?.id === 'format',
                                    'sticky right-0 z-2 w-[76px] bg-white dark:bg-icoDarkMode-anthracite':
                                        column?.id === 'download' || column?.id === 'edit',
                                    'cursor-pointer': column?.sortable
                                }
                            )}>
                            <span className="flex items-center space-x-1">
                                {column?.sortable &&
                                requestParams?.sort?.column === column?.sortable ? (
                                    <Icon
                                        className="align-bottom text-sm"
                                        icon={clsx({
                                            'chevron-bottom': requestParams?.sort?.order === 'desc',
                                            'chevron-top': requestParams?.sort?.order === 'asc'
                                        })}
                                    />
                                ) : null}
                                <span>{column.render('Header')}</span>
                            </span>
                        </th>
                    ))}
                </tr>
            ))}
        </thead>
    );
};

TableHead.propTypes = {
    headerGroups: PropTypes.array,
    requestParams: PropTypes.object,
    setRequestParams: PropTypes.func
};

export default TableHead;
